export const UPDATE_MONITOR_DATA = 'UPDATE_MONITOR_DATA';
export const REPLACE_MONITOR_DATA = 'REPLACE_MONITOR_DATA';
